<template>
  <el-row v-gutter="gutter > 1 ? gutter : 0"
          class="container">
    <div :class="['left-container', leftShadow ? 'left-shadow' : '']"
         :style="{'min-width': leftWidth, 'max-width': leftWidth, borderRight: gutter === 1 ? '1px solid #EEEFF0' : ''}">
      <slot name="left"></slot>
    </div>
    <!-- <div class="right-container" :style="rightStyle"> -->
    <div class="right-container">
      <div class="right-container-bg">
        <slot name="right"></slot>
      </div>
    </div>
  </el-row>
</template>

<script>
  import {addPx} from "../../../../utils/common";

  export default {
    name: "app-left-right",
    props: {
      adaptType: {
        type: String,
        default: 'calc',
        validator: function (value) {
          return ['calc', 'flex'].indexOf(value) !== -1
        }
      },
      leftWidth: {
        type: String,
        default: '230px'
      },
      leftShadow: {
        type: Boolean,
        default: true,
      },
      gutter: {
        type: Number,
        default: 10
      }
    },
    computed: {
      rightStyle() {
        switch (this.adaptType) {
          case 'calc':
            return {width: `calc(100% - ${addPx(this.leftWidth, '32')}`};
          case 'flex':
            return {
              flex: 1,
              'overflow-x': 'hidden'
            };
          default:
            return {};
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;
    /* justify-content: space-between; */
  }
  .left-container {
    background: #fff;
  }
  .left-shadow {
    /* box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15); */
  }
  .right-container{
    height: 100%;
    width: 0;
    flex: 1;
    flex-basis: 0;
    padding-left: 16px;
    margin: 0 !important;
  }
  .right-container-bg{
    background: #fff;
    padding: 16px;
    box-sizing: border-box;
    width: 100%;
    height:  100%;
    &/deep/.base-main{
      width: 100% ;
      height: 100% ;
    }
  }
</style>
